import React, { useState, useEffect } from "react";
import { PostFieldLabel, PlatformUsage } from "components/Posts/PostForm";
import { FIELDS } from "constants/PostFormFields";
import { useDebouncedCallback } from "use-debounce";
import { Input } from "@/components/ui/input";
import { useRegisterFlush } from "../platform-fields/flush-registry";

const YouTubeTitle = ({
  url,
  post,
  field,
  checkSetting = false,
  selectedPlatform,
  selectedAccounts,
  platforms,
  title,
  className = "",
  onChange,
  disabled = false,
}) => {
  const [value, setValue] = useState("");
  useEffect(() => {
    if (post["ytTags"]) {
      setValue(post["ytTags"]);
    }
  }, []);

  const bounce = useDebouncedCallback((value) => {
    let title = post["ytTags"];
    if (value != title) {
      onChange(value);
    }
  }, 200);
  useRegisterFlush(bounce.flush);

  return (
    <div className={className}>
      <div className="flex flex-col mb-4">
        <div className="flex items-center mb-2 ">
          <PostFieldLabel className="mr-2">{title}</PostFieldLabel>
          <PlatformUsage
            platforms={platforms}
            field={FIELDS.YT_TAGS}
            selectedPlatform={selectedPlatform}
          />
        </div>
        <Input
          value={value}
          placeholder="cat, dog, rabbit, …"
          disabled={disabled}
          aria-invalid={value.length > 400 || undefined}
          className="h-8 !border-neutral-100 px-3.5 py-1.5 font-normal aria-invalid:!border-red-500 aria-invalid:!shadow-[0_0_0_2px_rgba(239,68,68,0.08),0_1px_2px_rgba(16,24,40,0.05)]"
          onChange={(event) => {
            const newVal = event.target.value;
            setValue(newVal);
            bounce(newVal);
          }}
        />
        {value.length > 400 && (
          <p className="mt-1 font-inter text-sm font-normal leading-5 text-red-500">
            YouTube tags must be 400 characters or fewer.
          </p>
        )}
      </div>
    </div>
  );
};

export default YouTubeTitle;
